import { FC } from 'react'
import { useInView } from 'react-intersection-observer'

import { resizeGdbImage } from 'utils'
import { useLocale } from 'languages/use-locale'
import { Program } from 'types'
import { OpenDirectIcon } from 'components/icons/open-direct-icon'
import { OpenUrlAniIcon } from '../icons/OpenUrlAniIcon'
import {
  ProgramStyle,
  StyledLink,
  StyledIcon,
  Category,
  RightColumn,
  LeftColumn,
  Title,
  Info,
} from './styled'

type Props = {
  program: Program
}

export const ProgramContainer: FC<Props> = ({ program }) => {
  const { texts } = useLocale()
  const { ref: buttonRef, inView: isButtonInView } = useInView({
    threshold: 0,
  })

  if (!program) {
    return null
  }

  return (
    <ProgramStyle color={program.category?.color}>
      <LeftColumn>
        <svg viewBox="0 0 16 9"></svg>
        <img
          src={resizeGdbImage(program.altPicture || program.picture, 1200)}
          alt=""
          style={{ objectPosition: program.photoPosition }}
        />
      </LeftColumn>
      <RightColumn>
        <div>
          <Category>{program.category?.name}</Category>

          <Title>
            {!isButtonInView ? (
              <a href={program.urlSite} target="_blank">
                {program.title}
                <StyledIcon>
                  <OpenUrlAniIcon />
                </StyledIcon>
              </a>
            ) : (
              program.title
            )}
          </Title>

          <Info>{program.info}</Info>

          <p
            dangerouslySetInnerHTML={{ __html: program.description as string }}
          />

          <>
            {!!program.urlSite && (
              <StyledLink href={program.urlSite} target="_blank" hideOnMobile>
                {texts.others.openShowPage}
                <OpenUrlAniIcon />
              </StyledLink>
            )}

            {!!program.urlDirect && (
              <StyledLink
                ref={buttonRef}
                href={program.urlDirect}
                target="_blank"
              >
                {texts.others.directLink}
                <OpenDirectIcon />
              </StyledLink>
            )}
          </>
        </div>
      </RightColumn>
    </ProgramStyle>
  )
}
